import { Controller } from "@hotwired/stimulus"
import { track } from "../analytics/mixpanel"

// Light/dark theme switcher for the partner dashboard. Mirrors the landing
// ThemeProvider: toggles `.dark` on <html>, persists to localStorage under the
// shared "theme" key, and falls back to the OS preference when unset. The FOUC
// guard that applies the class before paint lives inline in the layout <head>;
// this controller only handles the toggle + icon state after hydration.
export default class extends Controller {
  static targets = ["sun", "moon"]

  connect() {
    this.render(this.current())
  }

  toggle() {
    const next = this.current() === "dark" ? "light" : "dark"
    localStorage.setItem("theme", next)
    this.apply(next)
    this.render(next)
    track("Partner Theme Toggled", { theme: next })
  }

  current() {
    const stored = localStorage.getItem("theme")
    if (stored === "dark" || stored === "light") return stored
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  }

  apply(theme) {
    document.documentElement.classList.toggle("dark", theme === "dark")
  }

  render(theme) {
    if (this.hasSunTarget) this.sunTarget.classList.toggle("hidden", theme !== "dark")
    if (this.hasMoonTarget) this.moonTarget.classList.toggle("hidden", theme === "dark")
  }
}
